import { render, staticRenderFns } from "./checkDR.vue?vue&type=template&id=c98452ea&scoped=true"
import script from "./checkDR.vue?vue&type=script&lang=js"
export * from "./checkDR.vue?vue&type=script&lang=js"
import style0 from "./checkDR.vue?vue&type=style&index=0&id=c98452ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98452ea",
  null
  
)

export default component.exports